import { styleClasses } from '../../constants/adjustments-and-reclasses/styleClasses.contant';

export type StyleClassType = typeof styleClasses[number];
